export default __webpack_public_path__ + "static/media/ar-bikee.74fb2ade.jpg";